module.exports = __webpack_public_path__ + "static/media/logo-verified-me.9d21674a.svg";